import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import values from 'lodash/values'

import { IQuestion } from 'cat-shared/utils'
import { AppButton, AppDivider, AppGroup } from 'client/ui-building-blocks'
import { Question } from 'client/components'
import { useAppContext, usePage } from 'client/hooks'
import { fixScrollPosition } from 'client/helpers'

import { type View } from '../create-question-page'

type Props = {
  isCreatingQuestion: boolean
  setActiveView: (view: View) => void
  onSubmit: () => void
}

const QuestionPreview = ({ isCreatingQuestion, setActiveView, onSubmit }: Props) => {
  const { t } = useTranslation()

  const { authUser } = useAppContext()
  const { navigateTo } = usePage()
  const { getValues } = useFormContext()

  const { type, category, text, options, correctOptions } = getValues()

  const question = {
    type,
    creatorId: authUser?._id,
    createdAt: Date.now(),
    category,
    text,
    options: values(options).filter(o => o),
    correctOptions,
  } as IQuestion

  const onBackClick = () => {
    setActiveView('FORM')
    fixScrollPosition(false)
  }

  const onCancelClick = () => {
    navigateTo({ path: '/home' })
  }

  const onCreateClick = () => {
    return onSubmit()
  }

  return (
    <>
      <Question question={question} previewMode />
      <AppDivider size="large" />
      <AppGroup fullWidth="mobile" position="right" gapSize="xxsmall">
        <AppButton
          variant="outlined"
          text={t('common.buttons.cancel')}
          onClick={onCancelClick}
          disabled={isCreatingQuestion}
        />
        <AppButton
          variant="success"
          type="reset"
          text={t('common.buttons.back')}
          iconName="CHEVRON_LEFT"
          onClick={onBackClick}
          disabled={isCreatingQuestion}
        />
        <AppButton
          variant="info"
          loading={isCreatingQuestion}
          text={t('common.buttons.create')}
          onClick={onCreateClick}
        />
      </AppGroup>
    </>
  )
}

export default QuestionPreview
